fx.ns("shared.popups", class GooglePhotosError extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personNotHappy );

        this.contentWidth = 550;
        this.contentHeight = 230;
    }

    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text:fx.text("Je n'ai pas pu récupérer vos photos"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("Un problème problème technique est arrivé, vos photos n'ont pu être récupérées. Veuillez-ré-essayer ou <a href='/contact' target='_blank'>contacter notre service client</a>."), className:"text center"}));

        this.addFooterChild("close");
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onClose, this.closeBtn);
    }

});